import axios from 'axios';

export const fetchAndDownloadReport = async (url, filename) => {
  try {
    const { data } = await axios.get(url, { responseType: 'blob' });

    const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = filename;
    downloadLink.click();
  } catch (error) {
    if (error.response) {
      console.error('Server responded with an error:', error.response.data);
    } else {
      console.error('Error sending request:', error.message);
    }
  }
};

export const getLotRefsForDispute = (catalogs, memberID) => {
  const memberData = catalogs?.items?.filter(item => item.memberID === memberID);

  return memberData
    .map(item => item.lotRef)
    .flat();
};
